export const PLAYER_INVITE_MAX_BATCH = 50;

const EMAIL_FULL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

function splitFullName(full) {
  const bits = String(full || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!bits.length) return { firstName: "", lastName: "" };
  if (bits.length === 1) return { firstName: bits[0], lastName: "" };
  return { firstName: bits[0], lastName: bits.slice(1).join(" ") };
}

function isHeaderLine(line) {
  const lower = String(line || "").trim().toLowerCase();
  if (!lower) return false;
  if (/e-?mail/.test(lower) && /(first|last|prénom|prenom|nom|name|vorname|nachname)/.test(lower)) {
    return true;
  }
  return /^(first\s*name|prénom|prenom|vorname|nombre|voornaam)\b/.test(lower);
}

export function parsePlayerInviteLine(line) {
  const raw = String(line || "").trim();
  if (!raw) return null;

  const angle = raw.match(/^(.*?)\s*<([^<>]+)>\s*$/);
  if (angle && EMAIL_FULL.test(angle[2].trim())) {
    const names = splitFullName(angle[1]);
    return {
      firstName: names.firstName,
      lastName: names.lastName,
      email: angle[2].trim().toLowerCase(),
    };
  }

  const parts = raw
    .split(/[,;\t]+/)
    .map((part) => part.trim())
    .filter(Boolean);
  if (!parts.length) return null;

  const fromParts = (chunks) => {
    const emailIdx = chunks.findIndex((part) => EMAIL_FULL.test(part));
    if (emailIdx < 0) return null;
    const email = chunks[emailIdx].toLowerCase();
    const rest = chunks.filter((_, idx) => idx !== emailIdx);
    if (!rest.length) return { firstName: "", lastName: "", email };
    if (rest.length === 1) {
      const names = splitFullName(rest[0]);
      return { firstName: names.firstName, lastName: names.lastName, email };
    }
    return {
      firstName: rest[0],
      lastName: rest.slice(1).join(" "),
      email,
    };
  };

  const delimited = fromParts(parts);
  if (delimited && parts.length > 1) return delimited;

  const tokens = raw.split(/\s+/).filter(Boolean);
  return fromParts(tokens) || delimited;
}

export function parsePlayerInviteList(raw, { max = PLAYER_INVITE_MAX_BATCH } = {}) {
  const text = String(raw || "").trim();
  if (!text) return [];

  const lines = text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const rows = [];
  const seen = new Set();
  for (const line of lines) {
    if (isHeaderLine(line)) continue;
    const parsed = parsePlayerInviteLine(line);
    if (!parsed?.email) continue;
    if (seen.has(parsed.email)) continue;
    seen.add(parsed.email);
    rows.push(parsed);
    if (rows.length >= max) break;
  }
  return rows;
}

export function isValidInviteEmail(email) {
  return EMAIL_FULL.test(String(email || "").trim());
}
